

const isValidDate = (val) => {
  const datePart = val.split('T')[0];
  const date = new Date(datePart);
  if (isNaN(date.getTime())) return false; // Not a valid date

  // Normalize both dates to midnight
  const input = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return input >= today;
};

// urlValidator.js
const expectedFlightParams = {
  //searbar filter parameter
  destination: (val) => /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(val),
  destination1: (val) => /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(val),
  destination2: (val) => /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(val),
  destination3: (val) => /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(val),
  destination4: (val) => /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(val),
  destination5: (val) => /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(val),
  destination6: (val) => /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(val),
  departure: (val) => /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(val),
  departure1: (val) => /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(val),
  departure2: (val) => /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(val),
  departure3: (val) => /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(val),
  departure4: (val) => /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(val),
  departure5: (val) => /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(val),
  departure6: (val) => /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(val),
  fcc: (val) => /^[A-Z]{3}$/.test(val),
  tcc: (val) => /^[A-Z]{3}$/.test(val),
  fcc1: (val) => /^[A-Z]{3}$/.test(val),
  tcc1: (val) => /^[A-Z]{3}$/.test(val),
  fcc2: (val) => /^[A-Z]{3}$/.test(val),
  tcc2: (val) => /^[A-Z]{3}$/.test(val),
  fcc3: (val) => /^[A-Z]{3}$/.test(val),
  tcc3: (val) => /^[A-Z]{3}$/.test(val),
  fcc4: (val) => /^[A-Z]{3}$/.test(val),
  tcc4: (val) => /^[A-Z]{3}$/.test(val),
  fcc5: (val) => /^[A-Z]{3}$/.test(val),
  tcc5: (val) => /^[A-Z]{3}$/.test(val),
  fcc6: (val) => /^[A-Z]{3}$/.test(val),
  tcc6: (val) => /^[A-Z]{3}$/.test(val),
  DepartureDate: '2025-05-04',
  DepartureDate1: '2025-05-04',
  DepartureDate2: '2025-05-04',
  DepartureDate3: '2025-05-04',
  DepartureDate4: '2025-05-04',
  DepartureDate5: '2025-05-04',
  DepartureDate6: '2025-05-04',
  ReturnDate: '2025-05-11',
  FromId: 'encrypted',
  ToId: 'encrypted',
  adults: (val) => Number(val) > 0 && Number(val) <= 9,
  children: (val) => Number(val) >= 0 && Number(val) <= 9,
  infants: (val) => Number(val) >= 0 && Number(val) <= 9,
  tripType: (val) => typeof val === "string",
  FlightCabinClass: (val) => typeof val === "string",
  class: (val) => typeof val === "string",
  DepartureDate: (val) => isValidDate(val),
  DepartureDate1: (val) => isValidDate(val),
  DepartureDate2: (val) => isValidDate(val),
  DepartureDate3: (val) => isValidDate(val),
  DepartureDate4: (val) => isValidDate(val),
  DepartureDate5: (val) => isValidDate(val),
  DepartureDate6: (val) => isValidDate(val),
  ReturnDate: (val) => isValidDate(val),

  //side filter parameter
  DirectFlight: ['false', 'true'],
  OneStopFlight: ['false', 'true'],
  IsAllowedOvernightStopOvers: ['false', 'true'],
  IsCheapest: ['false', 'true'],
  IsFastest: ['false', 'true'],
  price: (val) => !isNaN(val),

  PreferredAirlines: (val) => { return Array.isArray(val) || typeof val === "string" },
  DepartureStartTime: (val) => { if (val === "null") { return true } else { return isValidDate(val) } },
  DepartureEndTime: (val) => { if (val === "null") { return true } else { return isValidDate(val) } },
  ArrivalStartTime: (val) => { if (val === "null") { return true } else { return isValidDate(val) } },
  ArrivalEndTime: (val) => { if (val === "null") { return true } else { return isValidDate(val) } },
  ReturnArrivalStartTime: (val) => { if (val === "null") { return true } else { return isValidDate(val) } },
  ReturnArrivalEndTime: (val) => { if (val === "null") { return true } else { return isValidDate(val) } },
  ReturnDepartureStartTime: (val) => { if (val === "null") { return true } else { return isValidDate(val) } },
  ReturnDepartureEndTime: (val) => { if (val === "null") { return true } else { return isValidDate(val) } },
  isExplore:(val)=> typeof JSON.parse(val) === "boolean"
};


// urlValidator.js
export function validateFlightSearchUrl(url) {
  const params = url;

  for (const key in params) {
    const value = params?.[key];

    if (!value && key !== 'PreferredAirlines') {
      return false;
    }

    let validator;
    let isValid;

    if (key === 'FromId' || key === 'ToId') {
      // validator = expectedFlightParams[key];
      // isValid = decryptUrlDatapattern(value) ? true : false;
    } else {
      validator = expectedFlightParams[key];
      isValid = typeof validator === "function" ? validator(value) : validator?.includes(value);
    }

    if (['adults', 'children', 'infants']?.includes(key)) {
      let adults = Number(params?.['adults']) > 0 ? Number(params?.['adults']) : 0,
        children = Number(params?.['children']) > 0 ? Number(params?.['children']) : 0,
        infants = Number(params?.['infants']) > 0 ? Number(params?.['infants']) : 0
      if ((adults + children + infants) > 9) {
        console.log("`Invalid value for ${key}: ${value}` ", `Invalid value for ${key}: ${value}`)
        return false;
      }
    }

    if (!isValid) {
      console.log("`Invalid value for ${key}: ${value}` ", `Invalid value for ${key}: ${value}`)
      return false;
    }
  }

  return true;
}
